import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BaseMUIDataTable from './BaseMUIDataTable/BaseMUIDataTable';
import { formatCsvFileName, formatDateTime } from '../helpers/formatters';
import { fetchUserLogs } from '../actions/logs';
import { DateFilterOptions } from '../helpers/MuiTableCustomFilters';

const UserLogsTable = ({ tableId, userId }) => {
  const dispatch = useDispatch();
  const logs = useSelector((state) => state.entities.logs);
  const userLogs = logs.byUserId[userId];

  useEffect(() => {
    dispatch(fetchUserLogs(userId));
  }, [userId]);

  const dateCustomBodyRender = (value) => {
    if (!value) {
      return '-';
    }
    const formattedDate = formatDateTime(value, true);

    return formattedDate;
  };

  const typeCustomBodyRender = (value) => {
    switch (value) {
      case 'RESCUE_CLAIM':
        return 'Claimed Rescue';
      case 'RESCUE_UNADOPT':
        return 'Adopted Rescue Released';
      case 'USER_MODIFIED':
        return 'User Modified';
      case 'USER_ROLE_ATTACH':
        return 'Role Added';
      case 'RECEIVING_AGENCY_CREATED':
        return 'Receiving Agency Created';
      case 'RECEIVING_AGENCY_MODIFIED':
        return 'Receiving Agency Modified';
      case 'RESCUE_ADOPT':
        return 'Adopted Rescue';
      case 'DONOR_CREATED':
        return 'Created Donor';
      case 'DONOR_MODIFIED':
        return 'Modified Donor';
      case 'MARKETING_HUB_ACCOUNT_LINKED':
        return 'Social Media Account Linked';
      case 'MARKETING_HUB_FEED_ENGAGED':
        return 'Marketing Hub Feed Engaged';
      case 'MARKETING_HUB_POST_CREATED':
        return 'Marketing Hub Post Created';
      case 'USER_ROLE_DETACH':
        return 'Role Removed';
      case 'DONATION_MODIFIED':
        return 'Modified Rescue';
      case 'DONOR_DELETED':
        return 'Deleted Donor';
      case 'USER_LOGGED_IN':
        return 'Logged in';
      case 'RESCUE_RELEASE':
        return 'Rescue released';
      default:
        return value || 'N/A';
    }
  };

  return (
    <BaseMUIDataTable
      tableId={tableId}
      title="User Logs"
      data={userLogs}
      columns={[
        {
          name: 'id',
          label: 'ID',
          options: {
            filter: false,
            sort: false,
            display: false,
          },
        },
        {
          name: 'created_at',
          label: 'Date',
          options: {
            sort: true,
            filter: true,
            ...DateFilterOptions,
            customBodyRender: (value) => dateCustomBodyRender(value),
            customBodyRenderCSV: (value) => dateCustomBodyRender(value),
          },
        },
        {
          name: 'action_type',
          label: 'Event',
          options: {
            sort: true,
            filterType: 'multiselect',
            customFilterListOptions: {
              render: (value) => `Type: ${value}`,
            },
            customBodyRender: (value) => typeCustomBodyRender(value),
            customBodyRenderCSV: (value) => typeCustomBodyRender(value),
          },
        },
      ]}
      options={{
        selectableRows: 'none',
        responsive: 'simple',
        downloadOptions: {
          filename: formatCsvFileName('Activities'),
        },
        sortOrder: {
          name: 'created_at',
          direction: 'desc',
        },
      }}
    />
  );
};

export default UserLogsTable;
